import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { getPageSeo, type WpSeo } from "@/lib/seo";

export type UsePageSeoOptions = {
  lang?: string;
  enabled?: boolean;
};

export function usePageSeo(slugs: string | string[], options?: UsePageSeoOptions) {
  const normalizedSlugs = useMemo(() => {
    const list = Array.isArray(slugs) ? slugs : [slugs];
    return list
      .map((slug) => slug.trim())
      .filter(Boolean)
      .map((slug) => slug.toLowerCase());
  }, [slugs]);

  const lang = options?.lang?.trim().toLowerCase() || undefined;
  const enabled = (options?.enabled ?? true) && normalizedSlugs.length > 0;

  return useQuery<WpSeo | null>({
    queryKey: ["wp-seo", "page", lang ?? "default", normalizedSlugs],
    queryFn: () => getPageSeo(normalizedSlugs, lang),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    enabled,
  });
}
